import React, { useState, useEffect } from 'react';
import config from '../config/config';
import { toggleMapContentFullScreen } from '../services/fullScreenService';

const ICON_URLS = {
  timeline: `${config.icons.baseUrl}${config.icons.timeline}`,
  fullscreen: `${config.icons.baseUrl}${config.icons.fullscreen}`,
  fullscreenExit: `${config.icons.baseUrl}${config.icons.fullscreenExit}`,
}
const DESCRIPTION_FULLSCREEN = '全画面';

/**
 * 画面左下のボタン群コンポーネント
 */
const MapLeftControls = ({ mapRef, onMeasureClick }) => {
  const [isFullScreen, setIsFullScreen] = useState(false);

  useEffect(() => {
    const handleChange = () => {
      setIsFullScreen(!!document.fullscreenElement);
    };
    document.addEventListener('fullscreenchange', handleChange);
    return () => {
      document.removeEventListener('fullscreenchange', handleChange);
    };
  }, []);

  const handleFullScreen = () => {
    // map-contentをフルスクリーン
    toggleMapContentFullScreen().catch(() => {
    });
  };

  return (
    // モバイル端末で表示制御する項目についてはmap-controls.cssで指定(max-width: 768px）
    <div className="map-bottom-left-container">
      <div className="bottom-left-controls">
        <div className="bottom-left-control-row">
          {/* フルスクリーンボタン 右クリックメニューにも有 */}
          <button
            id="featured-fullscreen"
            className={`featured-control-btn ${isFullScreen ? 'active' : ''}`}
            onClick={handleFullScreen}
          >
            <span
              className="svg-icon-white"
              style={{
                backgroundImage: isFullScreen
                  ? `url('${ICON_URLS.fullscreenExit}')`
                  : `url('${ICON_URLS.fullscreen}')`,
                width: 24,
                height: 24,
                display: "inline-block"
              }}
            ></span>
            <span>{DESCRIPTION_FULLSCREEN}</span>
          </button>

        </div>
      </div>
    </div>
  );
};

export default MapLeftControls;